var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C5.6 2.5 2 6.1 2 10.5C2 14.9 5.6 18.5 10 18.5C14.4 18.5 18 14.9 18 10.5C18 6.1 14.4 2.5 10 2.5Z",
    fill: "#BABDCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4001 12.1H10.7001C11.0001 12.1 11.2001 11.9 11.2001 11.6L11.4001 5.5C11.4001 5.2 11.2001 5 10.9001 5H9.1001C8.8001 5 8.6001 5.2 8.6001 5.5L8.8001 11.6C8.9001 11.9 9.1001 12.1 9.4001 12.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.2C9.2001 13.2 8.6001 13.8 8.6001 14.6C8.6001 15.4 9.2001 16 10.0001 16C10.7001 16 11.4001 15.4 11.4001 14.6C11.4001 13.8 10.7001 13.2 10.0001 13.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation_mark.68adf785b8a60da6c44b40aa0265daf8.svg";
export { ForwardRef as ReactComponent };